/* src/app/pages/estatico-generico/estatico-generico.component.css */
.ratio-16x9 {
  position: relative;
  width: 100%;
  --bs-aspect-ratio: 56%;
  max-height: 500px;
  min-height: 250px;
  overflow: hidden;
}
.ratio-16x9 iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.iframe-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.iframe-container iframe {
  width: 100%;
  height: auto;
  min-height: 600px;
  border: none;
  display: block;
  object-fit: contain;
}
@media (min-width: 1200px) {
  .ratio-16x9 {
    --bs-aspect-ratio: 45%;
    max-height: 450px;
  }
}
@media (max-width: 768px) {
  .ratio-16x9 {
    --bs-aspect-ratio: 60%;
    max-height: 300px;
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/estatico-generico.component.css.map */
